export const GLOBAL_EVENTS = {
    DISABLE_INPUT: 'disable-input',
    ENABLE_INPUT: 'enable-input',
    SETUP_GAME: 'setup-game',
    START_GAME: 'start-game',
    END_GAME: 'end-game',
    UPDATE_SCORE: 'update-score',
    SHOW_FEEDBACK: 'show-feedback',
};
